module.exports = __webpack_public_path__ + "55a0a5fcda48979179ac4673108f4b95.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/logo-footer.png
// module id = 446
// module chunks = 0